module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "welcome-card",
    attrs: {
      "id": "app"
    }
  }, [_vm._h('div', {
    staticClass: "demo-card-wide mdl-card mdl-shadow--2dp"
  }, [_vm._m(0), " ", _vm._m(1), " ", _vm._m(2), " ", _vm._h('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_vm._h('router-link', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "to": "/data"
    }
  }, [_vm._h('i', {
    staticClass: "material-icons"
  }, ["timeline"])]), " ", _vm._h('router-link', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "to": "/map"
    }
  }, [_vm._h('i', {
    staticClass: "material-icons"
  }, ["explore"])])]), " ", _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "mdl-card__title"
  })
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "mdl-card__supporting-text"
  }, ["\n      This website is dedicated to visualizing bike data supplied by the City of Toronto. Specifically, this website\n        visualizes bicycle traffic throughout the downtown core. It is visualized in two ways; through charts/graphs\n        using D3JS and by using a map (coming soon).\n      "])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "mdl-card__supporting-text"
  }, ["\n      The purpose of visualizing this data is to help better understand the amount of bike traffic the City of Toronto\n      has on its roads, when it occurs the most, and where it occurs the most. Check out the visualization below.\n      "])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "mdl-card__menu"
  }, [_vm._h('button', {
    staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
  }, [_vm._h('i', {
    staticClass: "material-icons"
  }, ["share"])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6680b4ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 17
// module chunks = 1